import { keyframes } from 'design'

export const pulseKeyframes = keyframes({
  '0%': {
    opacity: 1,
  },
  '50%': {
    opacity: 0.3,
  },
  '100%': {
    opacity: 1,
  },
})
